'use client';

import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';

import {
  getDashboardBookingsChart,
  getDashboardCashflow,
  getDashboardMentees,
  getDashboardOverview
} from '@website/services/dashboardNew.service';

export function useDashboardOverview() {
  const locale = useLocale();
  return useQuery({
    queryKey: ['dashboard', 'overview', locale],
    queryFn: () => getDashboardOverview(locale),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2
  });
}

export function useDashboardCashflow(month: string) {
  return useQuery({
    queryKey: ['dashboard', 'cashflow', month],
    queryFn: () => getDashboardCashflow(month),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
    enabled: !!month
  });
}

export function useDashboardBookingsChart(month: string) {
  return useQuery({
    queryKey: ['dashboard', 'bookings-chart', month],
    queryFn: () => getDashboardBookingsChart(month),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
    enabled: !!month
  });
}

export function useDashboardMentees() {
  return useQuery({
    queryKey: ['dashboard', 'mentees'],
    queryFn: getDashboardMentees,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2
  });
}
